<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>
        <span class="fonints">司机姓名</span>
         <el-input
          placeholder="请输入关键词"
          v-model="conditions.driverName"
          clearable
        >
        </el-input>
        <span class="fonints">车辆所有人</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.carowner"
          clearable
        >
        </el-input>
       
      </div>
      <div class="componentSty_content_title_flex_button">
        <button class="buttons" @click="selectlist">查询</button>
      </div>
      </div>
      
      <div class="componentSty_content_table" style="border:none">
        <el-table
          :data="arrlist.list"
          style="width: 100%; height: 80%"
          @sort-change="sortchange"
          border
           height="80%"
        >
         <el-table-column show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" label="申请时间" prop="gmt_create">
            <template v-slot="res">
              {{ mydateFormat(res.row.gmtCreate, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号码"> </el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="hangPlate" label="挂车号码"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="driverName" label="司机姓名">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="telephone" label="手机号码"> </el-table-column> -->
          <el-table-column show-overflow-tooltip prop="discharge" label="排放标准"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cartype" label="车辆类型">
          <template v-slot="res">
              <span>{{
                res.row.cartype==1?'新能源车':res.row.cartype==2?'燃油车':'天然气车'
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="carowner" label="车辆所有人">
          </el-table-column> -->
          <el-table-column show-overflow-tooltip prop="iscustoms" label="海关监管">
            <template v-slot="res">
              <span>{{
                res.row.iscustoms==1?"监管":"非监管"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="fleetName" label="所属车队">
          </el-table-column> 
          <el-table-column show-overflow-tooltip label="操作">
            <template v-slot="res">
              <span
                class="iconfont icon-xiugai"
                @click="itemparticulars(res.row)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list&&arrlist.list.length">
          <el-pagination
            :page-size="arrlist.pageSize"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.total"
             :current-page="arrlist.pageNum"
            @current-change="getMemberlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "会员管理" }, { name: "新增审核" }],
      timeout: null,
      conditions:{},
      arrlist: [],
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({
        key: this.$route.path,
        val: { page: 1, limit: 20, order: "desc", sidx: "gmt_create",useStatus:0 },
      });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
      order: "desc",
      sidx: "gmt_create",
      useStatus:0
    };
    this.getMemberlist();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getMemberlist(num) {
       typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/driver/car/list",
        "get",
        this.conditions
      );
      if (!data || data.msg != "success")
        return this.$message.error("获取数据失败");
      this.arrlist = data.page;
    },
    itemparticulars(res) {
      window.sessionStorage.setItem("infoid", res.id);
      this.$router.push({ name: "newaddparticulars" });
    },
    sortchange(event) {
      if (event.prop) this.conditions.sidx = event.prop;
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getMemberlist();
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getMemberlist();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>